import { useSetRecoilState } from "recoil"
import { getDetailPharmacy, getPharmacistByToken, getPharmacyInfoLocal, setAccountInfo, setCurrentPharmacy } from "../api"
import { UserModel, LoginInfoModel } from "../models"
import { accountState } from "../recoil"

const usePharmacy = () => {
    const setAccountState = useSetRecoilState(accountState.accountDataState)

    return {
        getCurrentDetailPharmacy: async () => {
            const { pharmacyCode }: any = getPharmacyInfoLocal()

            return await getDetailPharmacy({ pharmacyCode }).then(res => {
                return res
            })
        },

        getPharmacistByToken: async (token: string) => {
            return await getPharmacistByToken(token).then(res => {
                const account = new LoginInfoModel({
                    doctor: new UserModel(res.doctor),
                    loginSession: { mToken: token, userLocalType: "PHARMACIST" }
                })

                setAccountInfo(account)
                setAccountState(account)

                setCurrentPharmacy({
                    pharmacyId: res.pharmacy.mId,
                    pharmacyCode: res.pharmacy.mPharCode,
                    pharmacyData: res.pharmacy
                })

                return res
            })
        },
    }
}

export default usePharmacy